import { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { CircleNotch, PlusCircle, CheckCircle, ClipboardText, Trash } from "@phosphor-icons/react";

const inputCls = "w-full rounded-lg bg-zinc-950/70 border border-zinc-800 focus:border-amber-500/60 outline-none px-3 py-2 text-sm text-zinc-100";
const VIDE = { texte: "", de: "", a: "", objet: "", date: "" };

/** Section 11 — boîte personnelle ralph646@hotmail.com (non reliée) : collage manuel des courriels, puis ajout à la chronologie. */
export function CourrielsPanel({ courriels = [], onUpdated }) {
  const [busy, setBusy] = useState(false);
  const [form, setForm] = useState(VIDE);
  const [ouvert, setOuvert] = useState(false);
  const [filtre, setFiltre] = useState("");

  const coller = async () => {
    setBusy(true);
    try {
      const r = await api.post("/brebeuf/courriels/coller", form);
      onUpdated({ courriels: [r.data, ...courriels], courriels_compte: r.data.compte });
      setForm(VIDE); setOuvert(false);
      toast.success("Courriel versé au dossier (source : ralph646@hotmail.com).");
    } catch (e) { toast.error(e?.response?.data?.detail || "Ajout impossible"); } finally { setBusy(false); }
  };
  const supprimer = async (c) => {
    if (!window.confirm("Retirer ce courriel du dossier ?")) return;
    try { await api.delete(`/brebeuf/courriels/${c.id}`); onUpdated({ courriels: courriels.filter((x) => x.id !== c.id) }); }
    catch (e) { toast.error(e?.response?.data?.detail || "Suppression impossible"); }
  };
  const ajouter = async (c) => {
    const logement = window.prompt("Logement concerné (876, 878, 876 + 878 ou —) :", "876 + 878");
    if (logement === null) return;
    try {
      const r = await api.post("/brebeuf/courriels/ajouter-chronologie", { id: c.id, logement });
      onUpdated({ courriels: courriels.map((x) => (x.id === c.id ? { ...x, ajoute: true } : x)), chronologie_append: r.data.evenement });
      toast.success("Ajouté à la chronologie (statut : constaté).");
    } catch (e) { toast.error(e?.response?.data?.detail || "Ajout impossible"); }
  };
  const visibles = courriels.filter((c) => !filtre || `${c.objet} ${c.de} ${c.a} ${c.extrait}`.toLowerCase().includes(filtre.toLowerCase()));
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <div className="space-y-4" data-testid="courriels-panel">
      <div className="rounded-xl border border-sky-500/30 bg-sky-500/5 p-4 text-sm text-sky-100/90" data-testid="courriels-info">
        Ce dossier utilise uniquement la boîte personnelle <b>ralph646@hotmail.com</b>. Hotmail n'est pas relié automatiquement : colle ici les courriels utiles (Rannou, Mino, Desjardins, Indemnipro, Qualinet) — ils sont classés comme sources et peuvent être ajoutés à la chronologie. Les réponses envoyées depuis le dossier indiquent cette adresse en « répondre à ».
      </div>
      <div className="flex flex-wrap items-center gap-3">
        <button type="button" onClick={() => setOuvert((o) => !o)} data-testid="courriels-coller-ouvrir" className="inline-flex items-center gap-2 rounded-full bg-amber-500 hover:bg-amber-400 text-zinc-950 font-bold px-4 py-2 text-sm">
          <ClipboardText weight="bold" /> Coller un courriel
        </button>
        <span className="text-xs text-zinc-500">{courriels.length} courriel(s) au dossier</span>
        {courriels.length > 0 && <input data-testid="courriels-filtre" className="ml-auto rounded-lg bg-zinc-950/70 border border-zinc-800 px-3 py-1.5 text-sm text-zinc-100" placeholder="Filtrer (Rannou, assureur…)" value={filtre} onChange={(e) => setFiltre(e.target.value)} />}
      </div>
      {ouvert && (
        <div className="rounded-xl border border-zinc-800 bg-zinc-900/50 p-4 space-y-3" data-testid="courriels-coller-form">
          <div className="grid md:grid-cols-2 gap-3">
            <label className="block text-xs text-zinc-400">De<input data-testid="courriel-de" className={`${inputCls} mt-1`} value={form.de} onChange={set("de")} placeholder="Nom <courriel>" /></label>
            <label className="block text-xs text-zinc-400">À<input data-testid="courriel-a" className={`${inputCls} mt-1`} value={form.a} onChange={set("a")} placeholder={"ralph646@hotmail.com"} /></label>
            <label className="block text-xs text-zinc-400">Objet<input data-testid="courriel-objet" className={`${inputCls} mt-1`} value={form.objet} onChange={set("objet")} /></label>
            <label className="block text-xs text-zinc-400">Date (AAAA-MM-JJ HH:MM)<input data-testid="courriel-date" className={`${inputCls} mt-1`} value={form.date} onChange={set("date")} /></label>
          </div>
          <label className="block text-xs text-zinc-400">Contenu du courriel (en-têtes De / À / Objet / Date détectés automatiquement s'ils sont présents)
            <textarea data-testid="courriel-texte" rows={8} className={`${inputCls} mt-1 font-mono text-[13px]`} value={form.texte} onChange={set("texte")} /></label>
          <button type="button" disabled={busy || form.texte.trim().length < 10} onClick={coller} data-testid="courriel-coller-valider" className="inline-flex items-center gap-2 rounded-full bg-emerald-500 hover:bg-emerald-400 text-zinc-950 font-bold px-4 py-2 text-sm disabled:opacity-50">
            {busy ? <CircleNotch className="animate-spin" /> : <PlusCircle weight="bold" />} Verser au dossier
          </button>
        </div>
      )}
      {courriels.length === 0 && <p className="text-sm text-zinc-500 italic" data-testid="courriels-vide">Aucun courriel au dossier. Colle le premier courriel utile ci-dessus.</p>}
      <ul className="space-y-2">
        {visibles.map((c) => (
          <li key={c.id} className="rounded-xl border border-zinc-800 bg-zinc-900/50 p-3 flex gap-3 items-start" data-testid={`courriel-${c.id}`}>
            <div className="w-32 shrink-0 text-xs text-amber-300 font-bold">{(c.date || "—").replace("T", " · ")}</div>
            <div className="flex-1 min-w-0 text-sm">
              <div className="text-zinc-100 font-semibold truncate">{c.objet || "(sans objet)"}</div>
              <div className="text-xs text-zinc-500 truncate">De {c.de || "—"} — à {c.a || "—"}{c.cc ? ` — cc ${c.cc}` : ""}</div>
              <div className="text-xs text-zinc-400 mt-1 whitespace-pre-wrap">{c.texte || c.extrait}</div>
            </div>
            <div className="flex flex-col items-end gap-2 shrink-0">
              {c.ajoute ? <span className="inline-flex items-center gap-1 text-xs text-emerald-300"><CheckCircle weight="fill" /> Dans la chronologie</span>
                : <button type="button" onClick={() => ajouter(c)} data-testid={`courriel-ajouter-${c.id}`} className="inline-flex items-center gap-1 text-xs text-sky-300 hover:text-sky-200"><PlusCircle /> Ajouter à la chronologie</button>}
              {String(c.id).startsWith("coll-") && <button type="button" onClick={() => supprimer(c)} data-testid={`courriel-supprimer-${c.id}`} className="inline-flex items-center gap-1 text-xs text-zinc-500 hover:text-red-300"><Trash /> Retirer</button>}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
